import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
// @ts-expect-error - Swiper CSS 모듈은 타입 정의가 없습니다
import "swiper/css";
// @ts-expect-error - Swiper Pagination CSS 모듈은 타입 정의가 없습니다
import "swiper/css/pagination";
import { SwiperXImg } from "@/SwiperXImg";
import defaultImg from "$/images/defaultImg.png";

export interface CompanyMedia {
  url: string;
  mediaType?: string | null; // IMAGE | VIDEO
  thumbnailUrl?: string | null;
  representativeYn?: string | null;
}

interface CompanyImageSliderProps {
  fileUrls: string[];
  /** 사진/영상 통합 미디어(대표 먼저·순서). 있으면 한 슬라이더에서 영상은 재생 */
  media?: CompanyMedia[];
}

export const CompanyImageSlider = ({
  fileUrls,
  media,
}: CompanyImageSliderProps) => {
  const dummyData = [defaultImg];

  // media 가 없으면 기존 이미지 슬라이더 그대로
  if (!media || media.length === 0) {
    return (
      <div className="flex justify-center pt-5 pb-4 bg-white">
        <SwiperXImg data={fileUrls.length > 0 ? fileUrls : dummyData} />
      </div>
    );
  }

  // media 가 있으면 사진/영상 혼합 슬라이더 (영상 슬라이드는 재생 가능)
  return (
    <div className="flex justify-center pt-5 pb-4 bg-white">
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={16}
        slidesPerView={1}
        className="[&_.swiper-pagination-bullet-active]:!bg-yellow"
        style={{ width: "340px" }}
      >
        {media.map((m, index) => (
          <SwiperSlide key={index}>
            {m.mediaType === "VIDEO" ? (
              <video
                src={m.url}
                poster={m.thumbnailUrl ?? undefined}
                controls
                muted
                playsInline
                preload="metadata"
                className="w-full h-[220px] object-cover rounded-xl bg-black"
              />
            ) : (
              <img
                src={m.url}
                alt="매장 이미지"
                className="w-full h-[220px] object-cover rounded-xl"
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
